import { useState } from 'react';
import { Field } from 'formik';
import { Stack, Text, VStack } from '@chakra-ui/react';
import { FormControl, FormLabel } from 'components/v4';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { stackSpacing, formLabelStyling, stackStyling, descriptionStyling } from 'components/forms/new/formStyles';
import NumberField from 'components/forms/new/formikFormFields/NumberField';

const AzureChannelCountField = ({ darkMode, errors, touched }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!(errors?.maxChannel && touched?.maxChannel)}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling(true)}>
                <Stack>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Channel Count <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Maximum number of concurrent channels for this ACS service.
                    </Text>
                </Stack>
                <Stack flex="1" minWidth="450px">
                    <VStack width="110%" alignItems="normal">
                        <Field
                            component={NumberField}
                            name="maxChannel"
                            id="maxChannel"
                            placeholder="Enter channel count"
                            min={2}
                            validate={value => {
                                if (!value) return 'Channel count is required';
                                if (Number(value) < 2) return 'Channel Count needs at least 2 channels';
                                return undefined;
                            }}
                        />
                    </VStack>
                </Stack>
                {isHovered && (
                    <FieldToolTip
                        label="Enter the maximum number of concurrent channels for this ACS service (minimum 2)"
                        ariaLabel="channel-count-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default AzureChannelCountField;